import styled from 'styled-components';
import { CompanyInfoStyled } from '@shared/ui-components';

const CompanyInfoWrapper = styled.div<{ canManage: boolean }>`
  width: fit-content;
  height: fit-content;
  position: relative;

  ${CompanyInfoStyled} {
    margin: auto;
  }
`;

export const Styled = {
  CompanyInfoWrapper,
};
